import { render, staticRenderFns } from "./IconEmojiTab.vue?vue&type=template&id=521beab5"
import script from "./IconEmojiTab.vue?vue&type=script&lang=js"
export * from "./IconEmojiTab.vue?vue&type=script&lang=js"
import style0 from "./IconEmojiTab.vue?vue&type=style&index=0&id=521beab5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports